import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-tags',
  templateUrl: './tutorial-tags.component.html',
  styleUrls: ['./tutorial-tags.component.css']
})
export class TutorialTagsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}